// extracted by mini-css-extract-plugin
export var compactFilters = "_ej-4";
export var detailImage = "_ej-1";
export var dropdownContainer = "_ej-2";
export var imageContainer = "_ej-0";
export var selectedCard = "_ej-3";